<script setup></script>

<template>
  <div class="layout-footer pb-3">
    <img
      src="/demo/images/login/Logo_Original-1.png"
      alt="Logo"
      height="40"
      class="mr-2"
    />
  </div>
</template>
<style lang="scss" scoped></style>
